import { useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import { IDialogChildComponent } from "../../../../reducers/dialog";
import { useSnackbarMessages } from "../../../../yoello-lib/modules/components/snackbar/SnackbarContext";
import Styles from "../../../../scss/voidOrderDialog.module.scss";
import { IResponse } from "../../../../hooks/useOpenBanking";


interface IConfirmDialogProps extends IDialogChildComponent {
    data: any;
    handleAccount: (data: any) => IResponse
}

const useStyles = makeStyles({
    root: {
        background: "#F3F4F9",
        display: "flex",
        padding: "1rem",
        justifyContent: "center",
        "& >button": {
            margin: "0 1rem",
        }
    },
    cancelBtn: {
        backgroundColor: "#FFFFFF"
    },
    continueBtn: {
        borderColor: "#455681",
        color: "#455681",
    }
})
export function ConfirmDialog(props: IConfirmDialogProps) {
    const { onClose, data, handleAccount } = props;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { sendSnackbarMessage } = useSnackbarMessages()!;
    const { t } = useTranslation();
    const { root, cancelBtn, continueBtn } = useStyles();

    async function onClickContinue() {
        setIsLoading(true);
        try {
            const response: IResponse = await handleAccount(data);
            if (response.isSuccessful) {
                setIsLoading(false);
                onClose();
            } else {
                setIsLoading(false);
                if (response.data) {
                    sendSnackbarMessage(response.data.message, "error");
                }
            }
        } catch (error) {
            setIsLoading(false);
            sendSnackbarMessage("An Error Happened", "error");
        }
    }
    return <>
        {isLoading ? <div style={{ margin: "6rem 6rem", display: "flex", alignItems: "center", justifyContent: "center" }}><CircularProgress /></div> : <div className={`${Styles.VoidOrderDialogContainer} ${root}`}>
            <Button color="default" className={cancelBtn} variant="contained" onClick={onClose}>
                {t('misc.cancel')}
            </Button>
            <Button color="default" className={continueBtn} variant="outlined" onClick={onClickContinue}>
                {t('misc.continue')}
            </Button>
        </div>}
    </>
}